<template>
	<div class="fans-container">
		<div class="fansTotal">
			粉丝（{{total}}）
		</div>
		<div class="fansList" v-if="fanSiData.length">
			<div class="menu">
				<div class="menuItem">粉丝</div>
				<div class="menuItem">关注时间</div>
				<div class="menuItem">操作</div>
			</div>
			<div class="fansItem" v-for="(item,index) in fanSiData" :key="index">
				<div class="fans">
					<img class="avatar" :src="item.user.avatar" v-if="item.user && item.user.avatar" />
					<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
					{{item.user && item.user.user_nickname ? item.user.user_nickname : ''}}
				</div>
				<div class="time">
					{{item.create_time}}
				</div>
				<div class="operation">
					<div class="delete" @click="deleteFanSi(item)">
						移除粉丝
					</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination style="padding: .32rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fanSiData: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		created() {
			this.getFanSi()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.getFanSi()
			},
			getFanSi() {
				this.$api.post('/Hua/fensi', {
					type: 1,
					pagesize: 10,
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.fanSiData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			deleteFanSi(item) {
				this.$api.post('/Hua/del_fensi', {
					id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.getFanSi()
						this.$message.success(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.fans-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: .32rem .4rem;
	}

	.fansTotal {
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
		line-height: .22rem;
	}

	.fansList {
		display: flex;
		flex-direction: column;

		.menu {
			margin-top: .16rem;
			margin-bottom: .08rem;
			display: flex;
			align-items: center;

			.menuItem:nth-child(1) {
				padding-left: .82rem;
				width: 44%;
			}

			.menuItem:nth-child(2) {
				padding-left: .36rem;
				width: 40%;
			}

			.menuItem:nth-child(3) {
				width: 16%;
				text-align: center;
			}

			.menuItem {
				font-weight: 400;
				font-size: .14rem;
				color: #666666;
			}
		}

		.fansItem {
			display: flex;
			align-items: center;
			height: .8rem;
			border-bottom: .01rem solid #CCCCCC;

			.fans {
				padding-left: .42rem;
				width: 44%;
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;

				.avatar {
					margin-right: .12rem;
					width: .48rem;
					height: .48rem;
					object-fit: cover;
					border-radius: 50%;
				}
			}

			.time {
				width: 40%;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.operation {
				width: 16%;
				display: flex;
				align-items: center;
				justify-content: center;

				.delete {
					width: .88rem;
					height: .36rem;
					background: rgba(226, 147, 88, .2);
					border-radius: .04rme;
					font-weight: 400;
					font-size: .14rem;
					color: #E29358;
					line-height: .36rem;
					text-align: center;
					cursor: pointer;
				}
			}
		}
	}
</style>